<template>
    <flow-part :id="$options.name">
        <template #heading>
            <h2>Jouw huidige situatie</h2>
        </template>
        <template #content>
            <SelectInput v-model="dropdownOption" :options="providers" type="button" show-valid
                placeholder="Kies je leverancier" />
            <span class="step-divider">
                <span class="divider-text"> Of </span>
            </span>

            <div class="input-group vertical">
                <big-radio-input id="moving" v-model="radioOption" title="Ik ga verhuizen" name="current-provider-radio"
                    value="moving" @click="scrollIfPrefilled(radioOption, 'moving')" />
                <big-radio-input id="no-provider" v-model="radioOption" title="Onbekend/Geen"
                    name="current-provider-radio" value="no-provider"
                    @click="scrollIfPrefilled(radioOption, 'no-provider')" />
            </div>

            <StepInfoToggle title="Waarom mijn huidige leverancier?">
                <template #content>
                    Door je huidige leverancier te vragen, weten we of je in aanmerking
                    komt voor bepaalde kortingen of bijvoorbeeld een gunstig
                    verlengaanbod.
                </template>
            </StepInfoToggle>
        </template>
    </flow-part>
</template>

<script>
import StepInfo from '../../../../vue-elements/wizard/step/StepInfo.vue';
import StepInfoToggle from '../StepInfoToggle.vue';
import WizardStepMixin from '../../../../vue-elements/wizard/lib/WizardStepMixin.js';
import { energyAllProviders, sortProviders } from '../../../../../assets/js/variables/providers.js';
import FlowPart from '../FlowPart.vue';
import { useEnergyComparisonStore } from '../../stores/energyComparison.js';
import BigRadioInput from '../../../../vue-elements/input/BigRadioInput.vue';
import SelectInput from '../../../../vue-elements/input/SelectInput.vue';
import { setCurrentProviderInLocalStorage } from '../../../../../assets/js/helpers/postalCheck.js';

export default {
    name: 'CurrentProviderStep',
    components: {
        SelectInput,
        BigRadioInput,
        FlowPart,
        StepInfo,
        StepInfoToggle,
    },
    setup() {
        const comparisonStore = useEnergyComparisonStore();

        // expose to template and other options API hooks
        return {
            comparisonStore,
        };
    },
    mixins: [WizardStepMixin()],
    data() {
        return {
            dropdownOption: null,
            radioOption: null,
            value: '',
            providers: [],
        };
    },
    watch: {
        'comparisonStore.filters.currentProvider': {
            handler(value) {
                if (value == null) {
                    return;
                }
                if (value === 'moving' || value === 'no-provider') {
                    this.radioOption = value;
                } else if (value === 'unknown') {
                    this.radioOption = 'no-provider';
                } else {
                    this.dropdownOption = value;
                }
                setCurrentProviderInLocalStorage(value);
                this.comparisonStore.filters.step = null;
            },
            immediate: true,
        },
        radioOption(value) {
            if (value !== null) {
                this.dropdownOption = null;
                this.value = value;
            }
        },
        dropdownOption(value) {
            if (value !== null) {
                this.radioOption = null;
                this.value = value;
            }
        },
        value: {
            handler(option) {
                this.comparisonStore.filters.currentProvider = option;
                this.logAnalyticsEvent('compare-energy.wizard-step-complete', {
                    step: this.$options.name,
                    value: this.value,
                });
                this.nextStep();
            },
        },
    },
    created() {
        this.providers = sortProviders(energyAllProviders(), ['nuon', 'essent', 'eneco']);
        this.providers.push(
            {
                label: 'Geen i.v.m. verhuizing',
                value: 'moving',
            },
            {
                label: 'Onbekend/Geen',
                value: 'no-provider',
            },
        );
    },
    methods: {
        validate() {
            this.status = this.comparisonStore.filters.currentProvider !== null ? 'complete' : 'invalid';
        },
    },
};
</script>
